import { useScopedNumericQuery } from './useScopedNumericQuery';
import { apiClient, type DashboardBootstrap } from '@/services/apiClient';

// Fetches the foundation dashboard bootstrap payload (counts, feature flags,
// system status) from GET /api/dashboard/bootstrap. getBootstrap() never throws —
// it resolves to null when the API is unreachable, so consumers can render a
// safe offline state instead of crashing.
export function useDashboardBootstrap() {
  return useScopedNumericQuery<DashboardBootstrap | null>(['dashboard', 'bootstrap'], undefined,
    (options) => apiClient.getBootstrap(options), { refetchInterval: 60_000 });
}
